export const QUERY_KEYS = {
    BRAND: (name)=>[
            "brand",
            name
        ]
};
